import {
  ComponentBox,
  ComponentBoxHeaderFooter,
  ConfigObjectType,
  StateId,
  utils,
} from '@wallaby-ui/core';
import classNames from 'classnames';
import * as React from 'react';
import {defineMessages, useIntl} from 'react-intl';

import styles from './FilterBox.less';
import {FilterTree} from './FilterTree';
import UserFilterSaveButton from './UserFilterSaveButton';
import UserFiltersContainer from './UserFiltersContainer';
import {FilterSchema} from 'src/js/model/filters_config';

const I18N = defineMessages({
  TITLE: {
    id: 'filter.title',
    defaultMessage: 'ADD FILTER',
    description: 'title text for filter box',
  },
  HELP: {
    id: 'filter.help',
    defaultMessage:
      'This box is showing the filters that can be used for filtering.',
    description: 'help text for filter box',
  },
});

interface OwnProps {
  caseType?: number | string;
  config: ConfigObjectType;
  filteringStateId: StateId;
  filterAndSearchStateId: StateId;
  saveFilter: (filterName: string) => void;
  selectedFilters?: Record<string, any>[];
  serviceUrls: Record<string, any>;
  schema: FilterSchema;
}

type Props = OwnProps;

export const FilterBox: React.FC<Props> = (props) => {
  const {
    caseType,
    config,
    filterAndSearchStateId,
    filteringStateId,
    schema,
    saveFilter,
    selectedFilters,
    serviceUrls,
  } = props;
  const intl = useIntl();

  return (
    <div className={styles.dlFilterBox}>
      <ComponentBoxHeaderFooter
        titleText={utils.TranslateUtils.translate(I18N.TITLE, intl)}
        helpText={utils.TranslateUtils.translate(I18N.HELP, intl)}
      >
        <span
          className={classNames('float-end', styles.dlFilterBoxHeaderContent)}
        >
          {selectedFilters && selectedFilters.length > 0 ? (
            <UserFilterSaveButton
              isDisabled={selectedFilters.length <= 0}
              onClick={saveFilter}
            />
          ) : null}
        </span>
      </ComponentBoxHeaderFooter>
      <ComponentBox>
        <UserFiltersContainer
          config={config}
          filteringStateId={filteringStateId}
          filterAndSearchStateId={filterAndSearchStateId}
          serviceUrls={serviceUrls}
        />
        <FilterTree
          caseType={caseType}
          config={config}
          filteringStateId={filteringStateId}
          filterAndSearchStateId={filterAndSearchStateId}
          schema={schema}
          searchServiceUrl={serviceUrls.searchService}
        />
      </ComponentBox>
    </div>
  );
};

FilterBox.displayName = 'FilterBox';
